import './styles.scss';

import React, {useEffect} from "react";
import NotificationSettings from "../../notification-settings";

interface IProps {
  show: boolean;
  close(): void;
}

const NotificationsModal = (props: IProps):JSX.Element => {
  const {
    show,
    close
  } = props;


  useEffect(()=> {
    const mouseUpListener = (): void => close();
    document.removeEventListener('mousedown', mouseUpListener);
    document.addEventListener('mousedown', mouseUpListener);

    return () => {
      document.removeEventListener('mousedown', mouseUpListener);
    }
  },[close])

  return (<>
    <div
      onMouseDown={e=>e.stopPropagation()}
      className={'notification-modal border shadow rounded text-start mt-3' + (show? '': ' hidden')}
    >
      <NotificationSettings/>
    </div>
  </>)
}
export default NotificationsModal;
